import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default function Contact() {
  return (
    <div className="min-h-screen bg-[#f5f2f0]">
      <div className="bg-[#45394B] pb-20">
        <Header />
        <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">Get in Touch</h1>
          <p className="text-lg text-white/80 max-w-2xl">
            Have questions about our services? We'd love to hear from you. Reach out and we'll respond as soon as possible.
          </p>
        </div>
      </div>

      <main className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 -mt-10">
        <div className="bg-white rounded-[24px] p-8 md:p-12">
          <div className="grid md:grid-cols-2 gap-12">
            {/* Contact Form */}
            <div>
              <h2 className="text-2xl font-semibold text-[#2b262e] mb-6">Send us a Message</h2>
              <form className="space-y-5">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-[#6e6672] mb-2">
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    className="w-full px-4 py-3 bg-[#f5f2f0] border border-[#e8e1e6] rounded-xl text-[#2b262e] placeholder:text-[#a0969e] outline-none focus:ring-2 focus:ring-[#8a7490] focus:border-transparent transition-all"
                    placeholder="Your name"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-[#6e6672] mb-2">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="w-full px-4 py-3 bg-[#f5f2f0] border border-[#e8e1e6] rounded-xl text-[#2b262e] placeholder:text-[#a0969e] outline-none focus:ring-2 focus:ring-[#8a7490] focus:border-transparent transition-all"
                    placeholder="your@email.com"
                  />
                </div>

                <div>
                  <label htmlFor="subject" className="block text-sm font-medium text-[#6e6672] mb-2">
                    Subject
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    className="w-full px-4 py-3 bg-[#f5f2f0] border border-[#e8e1e6] rounded-xl text-[#2b262e] placeholder:text-[#a0969e] outline-none focus:ring-2 focus:ring-[#8a7490] focus:border-transparent transition-all"
                    placeholder="How can we help?"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-[#6e6672] mb-2">
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows={4}
                    className="w-full px-4 py-3 bg-[#f5f2f0] border border-[#e8e1e6] rounded-xl text-[#2b262e] placeholder:text-[#a0969e] outline-none focus:ring-2 focus:ring-[#8a7490] focus:border-transparent transition-all resize-none"
                    placeholder="Tell us more about your fitness goals or questions..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full px-6 py-3 bg-[#8a7490] text-white rounded-xl hover:bg-[#7a647d] transition-colors font-medium"
                >
                  Send Message
                </button>
              </form>
            </div>

            {/* Contact Info */}
            <div className="space-y-6">
              <div className="bg-[#f5f2f0] rounded-[18px] p-6">
                <h2 className="text-xl font-semibold text-[#2b262e] mb-4">Contact Information</h2>
                <div className="space-y-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-[#8a7490]/10 rounded-lg flex items-center justify-center">
                      <svg className="w-5 h-5 text-[#8a7490]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <div>
                      <p className="font-medium text-[#2b262e]">Email</p>
                      <p className="text-[#6e6672] text-sm">hello@femalefitnessfinder.com</p>
                    </div>
                  </div>

                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-[#8a7490]/10 rounded-lg flex items-center justify-center">
                      <svg className="w-5 h-5 text-[#8a7490]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                    </div>
                    <div>
                      <p className="font-medium text-[#2b262e]">Phone</p>
                      <p className="text-[#6e6672] text-sm">1-800-FITNESS</p>
                    </div>
                  </div>

                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-[#8a7490]/10 rounded-lg flex items-center justify-center">
                      <svg className="w-5 h-5 text-[#8a7490]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                    </div>
                    <div>
                      <p className="font-medium text-[#2b262e]">Location</p>
                      <p className="text-[#6e6672] text-sm">Online Worldwide</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-[#f5f2f0] rounded-[18px] p-6">
                <h2 className="text-xl font-semibold text-[#2b262e] mb-4">Business Hours</h2>
                <div className="space-y-3">
                  <div className="flex justify-between text-sm">
                    <span className="text-[#6e6672]">Monday - Friday</span>
                    <span className="font-medium text-[#2b262e]">9:00 AM - 8:00 PM</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-[#6e6672]">Saturday</span>
                    <span className="font-medium text-[#2b262e]">10:00 AM - 6:00 PM</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-[#6e6672]">Sunday</span>
                    <span className="font-medium text-[#2b262e]">12:00 PM - 4:00 PM</span>
                  </div>
                </div>
              </div>

              <div className="bg-[#f5f2f0] rounded-[18px] p-6">
                <h2 className="text-xl font-semibold text-[#2b262e] mb-4">Follow Us</h2>
                <div className="flex space-x-3">
                  <a href="#" className="w-10 h-10 bg-[#8a7490]/10 rounded-lg flex items-center justify-center hover:bg-[#8a7490]/20 transition-colors">
                    <svg className="w-5 h-5 text-[#8a7490]" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                    </svg>
                  </a>
                  <a href="#" className="w-10 h-10 bg-[#8a7490]/10 rounded-lg flex items-center justify-center hover:bg-[#8a7490]/20 transition-colors">
                    <svg className="w-5 h-5 text-[#8a7490]" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                    </svg>
                  </a>
                  <a href="#" className="w-10 h-10 bg-[#8a7490]/10 rounded-lg flex items-center justify-center hover:bg-[#8a7490]/20 transition-colors">
                    <svg className="w-5 h-5 text-[#8a7490]" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1112.324 0 6.162 6.162 0 01-12.324 0zM12 16a4 4 0 110-8 4 4 0 010 8zm4.965-10.405a1.44 1.44 0 112.881.001 1.44 1.44 0 01-2.881-.001z"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
